export enum ComponentFilterType {
  period = 'period',
  checkboxlist = 'checkbox-list',
  hierarchy = 'hierarchy',
  keyword = 'keyword',
  list = 'list'
}
